/** KEYBOARD ACTIONS */
export const UI_KEYBOARD_ACTIVE = 'UI_KEYBOARD_ACTIVE';
export const UI_KEYBOARD_INACTIVE = 'UI_KEYBOARD_INACTIVE';

/** SIDEBAR MESSAGES ACTIONS */
export const UI_SIDEBAR_MESSAGES_SHOW = 'UI_SIDEBAR_MESSAGES_SHOW';
export const UI_SIDEBAR_MESSAGES_HIDE = 'UI_SIDEBAR_MESSAGES_HIDE';
export const UI_SIDEBAR_ADD_MESSAGE = 'UI_SIDEBAR_ADD_MESSAGE';
export const UI_SIDEBAR_CLEAR_MESSAGES = 'UI_SIDEBAR_CLEAR_MESSAGES';
export const UI_SIDEBAR_REMOVE_MESSAGE = 'UI_SIDEBAR_REMOVE_MESSAGE';
export const UI_SIDEBAR_SET_DISPLAY = 'UI_SIDEBAR_SET_DISPLAY';

/** UPLOAD PROGRESS */
export const UI_UPLOAD_PROGRESS_SHOW = 'UI_UPLOAD_PROGRESS_SHOW';
export const UI_UPLOAD_PROGRESS_HIDE = 'UI_UPLOAD_PROGRESS_HIDE';
export const UI_UPLOAD_PROGRESS_CURRENT = 'UI_UPLOAD_PROGRESS_CURRENT';
export const UI_UPLOAD_PROGRESS_TOTAL = 'UI_UPLOAD_PROGRESS_TOTAL';
export const UI_RESET_UPLOAD_PROGRESS = 'UI_RESET_UPLOAD_PROGRESS';
export const UI_UPLOAD_PROGRESS_COMPLETE = 'UI_UPLOAD_PROGRESS_COMPLETE';
export const UI_CANCEL_UPLOAD = 'UI_CANCEL_UPLOAD';

/** NOTIFICATION SYSTEM */
export const UI_NOTIFICATION_ADD_MESSAGE = 'UI_NOTIFICATION_ADD_MESSAGE';
export const UI_NOTIFICATION_REMOVE_MESSAGE = 'UI_NOTIFICATION_REMOVE_MESSAGE';
export const UI_NOTIFICATION_INITIALIZE = 'UI_NOTIFICATION_INITIALIZE';

/** Header */
export const UI_HEADER_SET_DISPLAY = 'UI_HEADER_SET_DISPLAY';

/**CENTER MESSAGES ACTIONS */
export const UI_CENTER_MESSAGES_SHOW = 'UI_CENTER_MESSAGES_SHOW';
export const UI_CENTER_MESSAGES_HIDE = 'UI_CENTER_MESSAGES_HIDE';
export const UI_CENTER_MESSAGES_ACTIVE = 'UI_CENTER_MESSAGES_ACTIVE';
export const UI_CENTER_MESSAGES_INACTIVE = 'UI_CENTER_MESSAGES_INACTIVE';
export const UI_CENTER_ADD_MESSAGE = 'UI_CENTER_ADD_MESSAGE';
export const UI_CENTER_REMOVE_MESSAGE = 'UI_CENTER_REMOVE_MESSAGE';
export const UI_CENTER_CLEAR_MESSAGE = 'UI_CENTER_CLEAR_MESSAGE';
export const UI_REDIRECT_URL = 'UI_REDIRECT_URL';
export const UI_CLEAR_REDIRECT_URL = 'UI_CLEAR_REDIRECT_URL';
export const UI_CANCEL_PROCESS_ERROR = 'UI_CANCEL_PROCESS_ERROR';

/** Fullscreen */
export const UI_FULLSCREEN = 'UI_FULLSCREEN';



// WEBPACK FOOTER //
// ./src/common/UI/state/types.js